module.exports = __webpack_public_path__ + "img/_posmap1.c1cc4a56.png";